export const DEPOSIT_STATUSES = {
  NEW: -1,
  BOOKED: 1,
  ACTIVE: 11,
  REJECTED: 6,
  ONHOLD: 10,
};
